import _styled from "@emotion/styled/base";
function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
import { css } from '@emotion/react';
import { colors, rem, getResetByTag, utilityStyles } from '../../../../styles';
var defaultStyles = function defaultStyles() {
  return /*#__PURE__*/css("background-color:", colors.white, ";color:", colors.navy_500, ";max-height:", rem(500), ";overflow-y:auto;padding:", rem(16), ";position:relative;width:100%;flex:1;" + (process.env.NODE_ENV === "production" ? "" : ";label:defaultStyles;"));
};
var _ref = process.env.NODE_ENV === "production" ? {
  name: "1hcx8jb",
  styles: "padding:0"
} : {
  name: "17ze6do-isFlushPaddingStyles",
  styles: "padding:0;label:isFlushPaddingStyles;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};
var isFlushPaddingStyles = function isFlushPaddingStyles(_ref2) {
  var isFlushPadding = _ref2.isFlushPadding;
  if (isFlushPadding) {
    return _ref;
  }
};
var variantStyles = function variantStyles(_ref3) {
  var variant = _ref3.variant;
  switch (variant) {
    case 'gray':
      return /*#__PURE__*/css("background:", colors.coolGray_100, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:variantStyles;"));
    case 'cool-gray':
      return /*#__PURE__*/css("background:", colors.coolGray_200, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:variantStyles;"));
  }
};
var resetStyles = getResetByTag('div');
var StyledModalBody = /*#__PURE__*/_styled('div', process.env.NODE_ENV === "production" ? {
  target: "eai4n500"
} : {
  target: "eai4n500",
  label: "StyledModalBody"
})(resetStyles, defaultStyles, isFlushPaddingStyles, variantStyles, utilityStyles);
export default StyledModalBody;